<template>
  <div :class="'jobStatus jobStatus-'+color"></div>
</template>

<script>
export default {
  name: "Status",
  components: {},
  props: {
    color: String
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
.jobStatus {
  border-radius: 50%;
  width: 18px;
  height: 18px;
  &-yellow, &-amarelo {
    background-color: $orange-1;
  }
  &-green, &-verde {
    background-color: $green-8;
  }
  &-red, &-vermelho {
    background-color: $red-2;
  }
}
</style>
